export const data = [
  {
    "Title": "Battle of the Planets",
    "Issue #": 2,
    "Condition": "VF",
    "Website Notes": "Whitman Variant",
    "": "",
    "Cost Basis": 30,
    "__1": ""
  },
  {
    "Title": "Beetle Bailey",
    "Issue #": 49,
    "Condition": "VG/F",
    "Website Notes": "",
    "": "",
    "Cost Basis": 5,
    "__1": ""
  },
  {
    "Title": "Brothers Grimm",
    "Issue #": 1962,
    "Condition": "VG",
    "Website Notes": "",
    "": "",
    "Cost Basis": 5,
    "__1": ""
  },
  {
    "Title": "Checkmate",
    "Issue #": 1,
    "Condition": "VG/F",
    "Website Notes": "Photo Cvr",
    "": "",
    "Cost Basis": "",
    "__1": ""
  },
  {
    "Title": "Checkmate",
    "Issue #": 2,
    "Condition": "FN",
    "Website Notes": "Photo Cvr",
    "": "",
    "Cost Basis": "",
    "__1": ""
  },
  {
    "Title": "Flintstones Bigger and Boulder",
    "Issue #": 1,
    "Condition": "FN+",
    "Website Notes": "",
    "": "",
    "Cost Basis": 10,
    "__1": "Poon"
  },
  {
    "Title": "Hawaiian Eye",
    "Issue #": 1,
    "Condition": "F/VF",
    "Website Notes": "Photo Cvr",
    "": "",
    "Cost Basis": "",
    "__1": ""
  },
  {
    "Title": "Honey West",
    "Issue #": 1,
    "Condition": "VG",
    "Website Notes": "Photo Cvr",
    "": "",
    "Cost Basis": 1,
    "__1": ""
  },
  {
    "Title": "HR Puffnstuff",
    "Issue #": 1,
    "Condition": "VG/F",
    "Website Notes": "",
    "": "",
    "Cost Basis": 20,
    "__1": ""
  },
  {
    "Title": "I Spy",
    "Issue #": 1,
    "Condition": "GD",
    "Website Notes": "Photo Cvr",
    "": "",
    "Cost Basis": "",
    "__1": ""
  },
  {
    "Title": "I Spy",
    "Issue #": 3,
    "Condition": "F/VF",
    "Website Notes": "Photo Cvr",
    "": "2 avail",
    "Cost Basis": 25,
    "__1": ""
  },
  {
    "Title": "I Spy",
    "Issue #": 5,
    "Condition": "F/VF",
    "Website Notes": "Photo Cvr",
    "": "",
    "Cost Basis": 10,
    "__1": ""
  },
  {
    "Title": "Jet Dream",
    "Issue #": 1,
    "Condition": "FN",
    "Website Notes": 1968,
    "": "",
    "Cost Basis": 10,
    "__1": ""
  },
  {
    "Title": "Jonny Quest",
    "Issue #": 1,
    "Condition": "FN+",
    "Website Notes": 1962,
    "": "",
    "Cost Basis": 500,
    "__1": "Bednard"
  },
  {
    "Title": "Magnus Robot Fighter",
    "Issue #": 1,
    "Condition": "VG",
    "Website Notes": 1962,
    "": "",
    "Cost Basis": 55,
    "__1": ""
  },
  {
    "Title": "Mickey Mouse",
    "Issue #": 244,
    "Condition": "NM",
    "Website Notes": "Giant",
    "": "Gladstone",
    "Cost Basis": 15,
    "__1": ""
  },
  {
    "Title": "Mickey's Twice Upon a Christmas",
    "Issue #": "",
    "Condition": "NM",
    "Website Notes": "",
    "": "Gemstone",
    "Cost Basis": 15,
    "__1": ""
  },
  {
    "Title": "Mod Wheels",
    "Issue #": 1,
    "Condition": "NM-",
    "Website Notes": "",
    "": "",
    "Cost Basis": 15,
    "__1": ""
  },
  {
    "Title": "Secret Agent",
    "Issue #": 1,
    "Condition": "FN",
    "Website Notes": "Photo Cover",
    "": "",
    "Cost Basis": 5,
    "__1": ""
  },
  {
    "Title": "Secret Agent",
    "Issue #": 1,
    "Condition": "GD+",
    "Website Notes": "Photo Cover",
    "": "",
    "Cost Basis": "",
    "__1": ""
  },
  {
    "Title": "Secret Agent",
    "Issue #": 2,
    "Condition": "F/VF",
    "Website Notes": "Photo Cover",
    "": "",
    "Cost Basis": "",
    "__1": ""
  },
  {
    "Title": "Star Trek",
    "Issue #": 1,
    "Condition": "G/VG",
    "Website Notes": "",
    "": "",
    "Cost Basis": 20,
    "__1": ""
  },
  {
    "Title": "Star Trek",
    "Issue #": 52,
    "Condition": "VF-",
    "Website Notes": "",
    "": "",
    "Cost Basis": 15,
    "__1": ""
  },
  {
    "Title": "Star Trek",
    "Issue #": 53,
    "Condition": "VF+",
    "Website Notes": "",
    "": "",
    "Cost Basis": 15,
    "__1": ""
  },
  {
    "Title": "Star Trek",
    "Issue #": 56,
    "Condition": "F/VF",
    "Website Notes": "",
    "": "",
    "Cost Basis": 15,
    "__1": ""
  },
  {
    "Title": "Star Trek",
    "Issue #": 57,
    "Condition": "VF/NM",
    "Website Notes": "",
    "": "",
    "Cost Basis": 15,
    "__1": ""
  },
  {
    "Title": "Star Trek",
    "Issue #": 60,
    "Condition": "VF",
    "Website Notes": "",
    "": "",
    "Cost Basis": 15,
    "__1": ""
  },
  {
    "Title": "Supercar",
    "Issue #": 3,
    "Condition": "G/VG",
    "Website Notes": "",
    "": "",
    "Cost Basis": 15,
    "__1": ""
  },
  {
    "Title": "Supercar",
    "Issue #": 4,
    "Condition": "G/VG",
    "Website Notes": "",
    "": "",
    "Cost Basis": 15,
    "__1": ""
  },
  {
    "Title": "Thriller (Boris Karloff)",
    "Issue #": 1,
    "Condition": "F/VF",
    "Website Notes": "Giant",
    "": "",
    "Cost Basis": 35,
    "__1": ""
  },
  {
    "Title": "Turok",
    "Issue #": 123,
    "Condition": "VF-",
    "Website Notes": "",
    "": "",
    "Cost Basis": 10,
    "__1": ""
  },
  {
    "Title": "Turok",
    "Issue #": 126,
    "Condition": "VF/NM",
    "Website Notes": "Whitman",
    "": "",
    "Cost Basis": 10,
    "__1": ""
  },
  {
    "Title": "Turok",
    "Issue #": 127,
    "Condition": "NM-",
    "Website Notes": "Whitman",
    "": "",
    "Cost Basis": 10,
    "__1": ""
  },
  {
    "Title": "Turok",
    "Issue #": 128,
    "Condition": "NM-",
    "Website Notes": "Whitman",
    "": "",
    "Cost Basis": 10,
    "__1": ""
  },
  {
    "Title": "Turok",
    "Issue #": 129,
    "Condition": "NM-",
    "Website Notes": "Whitman",
    "": "",
    "Cost Basis": 10,
    "__1": ""
  },
  {
    "Title": "Turok Giant",
    "Issue #": "NN",
    "Condition": "VG",
    "Website Notes": 1966,
    "": "",
    "Cost Basis": 10,
    "__1": ""
  },
  {
    "Title": "Twilight Zone",
    "Issue #": 9,
    "Condition": "VG",
    "Website Notes": "",
    "": "",
    "Cost Basis": 5,
    "__1": ""
  },
  {
    "Title": "UFO Flying Saucers",
    "Issue #": 1,
    "Condition": "F/VF",
    "Website Notes": "Giant",
    "": "",
    "Cost Basis": 30,
    "__1": "BCC"
  },
  {
    "Title": "Walt Dsney's Christmas Parade (2003)",
    "Issue #": 1,
    "Condition": "NM",
    "Website Notes": "",
    "": "Gemstone",
    "Cost Basis": 10,
    "__1": ""
  },
  {
    "Title": "Walt Dsney's Christmas Parade (2003)",
    "Issue #": 2,
    "Condition": "NM",
    "Website Notes": "",
    "": "Gemstone",
    "Cost Basis": 10,
    "__1": ""
  },
  {
    "Title": "Walt Dsney's Christmas Parade (2003)",
    "Issue #": 3,
    "Condition": "NM",
    "Website Notes": "",
    "": "Gemstone",
    "Cost Basis": 10,
    "__1": ""
  },
  {
    "Title": "Walt Kelly's Christmas Classics",
    "Issue #": 1,
    "Condition": "NM",
    "Website Notes": "",
    "": "Eclipse",
    "Cost Basis": 10,
    "__1": ""
  },
  {
    "Title": "Yellow Submarine Beatles",
    "Issue #": "NN",
    "Condition": "CGC 9.2",
    "Website Notes": "W/Poster",
    "": "",
    "Cost Basis": 425,
    "__1": ""
  }
]
;
